import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useUnsavedChangesPrompt(when: boolean) {
  const navigate = useNavigate();
  const [showPrompt, setShowPrompt] = useState(false);
  const [lastLocation, setLastLocation] = useState<string | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(false);
  }, []);

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(true);
  }, []);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation);
      setConfirmedNavigation(false);
      setLastLocation(null);
    }
  }, [confirmedNavigation, lastLocation, navigate]);

  useEffect(() => {
    if (when) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [when]);

  const handleNavigate = useCallback(
    (path: string) => {
      if (when) {
        setShowPrompt(true);
        setLastLocation(path);
      } else {
        navigate(path);
      }
    },
    [when, navigate],
  );

  return { showPrompt, handleNavigate, cancelNavigation, confirmNavigation };
}
